export const iconFontAwesomeGamingSquareFull = (
	<i className="fa-solid fa-square-full"></i>
);
